import React from 'react';

class ShoppingCarouselItem extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <a
            className="shop_carousel__item cts-tracking-object" 
            data-cts-object-category="affiliate_carousel"
            data-cts-object-name={this.props.data.title}
            data-cts-object-url={this.props.data.link}
            data-cts-object-extra-info={JSON.stringify([{ type: 'product' }])}
            data-cts-object-placement={`${this.props.index + 1}`}
            id={`shop-car-product-${this.props.data.id}`} 
            data-product-title={this.props.data.title} 
            target="_blank" 
            rel="noopener noreferrer nofollow"
            href={this.props.data.link} >
                <span>
                    <img 
                    data-pin-nopin
                    loading="lazy"
                    src={this.props.data.image_link} 
                    alt={this.props.data.title} 
                    height="300" 
                    width="300"/>
                </span>
                <span className="shop_carousel__item__title">{this.props.data.title}</span>
                <span className="shop_carousel__item__price">{this.props.data.price}</span>
            </a>
        );
    }
}
export default ShoppingCarouselItem;